import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Stars } from '../components/Shared';
import { useAuth } from '../context/AuthContext';
import './NurseProfile.css';

export default function DoctorProfilePage() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/doctors/${id}`)
      .then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="page-loader">Loading profile…</div>;
  if (!data) return <div className="page-loader">Doctor not found</div>;

  const { doctor, reviews } = data;
  const u = doctor.user;

  return (
    <div className="np-page">
      <div className="container np-layout">
        {/* Left */}
        <div className="np-left">
          <div className="card np-card">
            <div className="np-avatar">{u?.firstName?.[0]}{u?.lastName?.[0]}</div>
            {doctor.isVerified && <div className="np-verified-badge">✅ Verified by SehatSehul</div>}
            <h1>{u?.firstName} {u?.lastName}</h1>
            <div className="np-spec">{doctor.specialization}</div>
            <div className="np-rating">
              <Stars rating={doctor.rating} size={18}/>
              <span>{doctor.rating.toFixed(1)}</span>
              <span>({doctor.totalReviews} reviews)</span>
            </div>
            <div className="np-stats">
              <div><strong>{doctor.experience || 0}</strong><span>Yrs Exp</span></div>
              <div><strong>{doctor.totalConsultations || 0}</strong><span>Consultations</span></div>
              <div><strong>{doctor.totalReviews}</strong><span>Reviews</span></div>
            </div>
            <div className="np-rate-box">
              <span className="np-rate">₨{doctor.consultationFee}<small>/consultation (30 min)</small></span>
            </div>
            <div className="np-actions">
              {user?.role === 'patient' ? (
                <button className="btn btn-teal" style={{width:'100%',justifyContent:'center'}} onClick={() => navigate(`/book-appointment/${id}`)}>
                  📅 Book Consultation
                </button>
              ) : !user ? (
                <Link to="/login?role=patient" className="btn btn-teal" style={{width:'100%',justifyContent:'center'}}>
                  Login to Book
                </Link>
              ) : null}
            </div>
            <div className="np-contact">
              {doctor.clinicAddress && <div>📍 {doctor.clinicAddress}</div>}
              {doctor.city && <div>🏙️ {doctor.city}</div>}
              {u?.email && <div>📧 {u.email}</div>}
              {u?.phone && <div>📞 {u.phone}</div>}
            </div>
          </div>

          {/* Availability */}
          <div className="card" style={{marginTop:'16px'}}>
            <h3 style={{marginBottom:'14px',fontSize:'15px',fontWeight:'700'}}>Consultation Hours</h3>
            {(doctor.availability || []).map((a, i) => (
              <div key={i} className={`avail-row ${!a.available ? 'unavail' : ''}`}>
                <span>{a.day}</span>
                <span>{a.available ? `${a.startTime} – ${a.endTime}` : 'Not available'}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right */}
        <div className="np-right">
          {doctor.bio && (
            <div className="card np-section">
              <h2>About</h2>
              <p>{doctor.bio}</p>
            </div>
          )}

          <div className="card np-section">
            <h2>Qualifications</h2>
            <div className="services-tags">
              <span>License: {doctor.medicalLicenseNumber}</span>
              <span>Registration: {doctor.registrationNumber}</span>
            </div>
          </div>

          <div className="card np-section">
            <h2>Patient Reviews ({reviews.length})</h2>
            {reviews.length === 0 ? (
              <p style={{color:'var(--muted)',fontSize:'14px'}}>No reviews yet. Be the first!</p>
            ) : reviews.map(r => (
              <div key={r._id} className="review-item">
                <div className="review-header">
                  <div className="review-avatar">{r.patient?.firstName?.[0]}</div>
                  <div>
                    <strong>{r.patient?.firstName} {r.patient?.lastName}</strong>
                    <Stars rating={r.rating} size={13}/>
                  </div>
                  <span className="review-date">{new Date(r.createdAt).toLocaleDateString()}</span>
                </div>
                {r.comment && <p className="review-text">{r.comment}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
